export const showStorePickupHeader = (display) => {
    if (display) {
        $('.shippingOptionHeader').hide();
        //$('.giftwrapHeader').hide();
        $('.pickupHeader').show();
        //$('.giftWrapColumn').hide(); 
        //$('.giftbox-wrapper').hide();
        
    }else{
        $('.shippingOptionHeader').show();
        //$('.giftwrapHeader').show();
        $('.pickupHeader').hide();
        //$('.giftWrapColumn').show(); 
        //$('.giftbox-wrapper').show();
    }
};
